import './LoaderComponent.scss';

function LoaderComponent(props: {size: string}) {
    return (
        <div className={`loader loader-${props.size}`}></div>
    )
}

export default LoaderComponent;
